import { render, staticRenderFns } from "./DocumentationEdit.vue?vue&type=template&id=38c89122"
import script from "./DocumentationEdit.vue?vue&type=script&lang=js"
export * from "./DocumentationEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports